var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{ fold: _vm.fold },on:{"click":_vm.toggleAnswer}},[_c('h3',[_c('i',[_vm._v("问")]),_c('span',{staticClass:"title32B"},[_vm._v(_vm._s(_vm.question))])]),_c('div',{staticClass:"answer"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }